import Vue from "vue";
import Router from "vue-router";
import instrumentRoute from "./modules/instrument";
import businessRoute from "./modules/business";
import businessApprovalRoute from "./modules/businessApproval";
import baseDataRoute from "./modules/baseData";
import sampleRoute from "./modules/sampleManagement";
import organizationRoute from "./modules/organization";
import environmentRoute from "./modules/environmentManagement";
import supplierRoute from "./modules/supplier";
import workPlanRoute from "./modules/workPlan";
import reagentRoute from "./modules/reagent";
import fileManagementRoute from "./modules/filesManagement";
import systemRoute from "./modules/system";

/* Layout */
import Layout from "@/layout";
import personRoute from "./modules/personManagement";

Vue.use(Router);

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-role_admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['role_admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  // {
  //   path: '/redirect',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/redirect/:path*',
  //       component: () => import('@/views/redirect/index')
  //     }
  //   ]
  // },
  // {
  //   path: '/auth-redirect',
  //   component: () => import('@/views/login/auth-redirect'),
  //   hidden: true
  // },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },

  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: {
          title: "驾驶舱",
          icon: "dashboard",
          affix: true
        }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  {
    path: "*",
    // redirect: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "/mobile/instrument/:id",
    component: () => import("@/views/instrumentManagement/mobile/index"),
    hidden: true
  },
  {
    path: '/userManagement',
    component: Layout,
    redirect: '/userManagement/chgPwd',
    name: 'userManagement',
    meta: {
      title: '用户管理',
      roles: ['ROLE_STAFF']
    },
    hidden: true,
    children: [
      {
        path: "chgPwd",
        component: () => import("@/views/user/chgPwd"),
        name: "chgPwd",
        meta: {
          title: "修改密码",
          icon: "userRole",
          activeMenu: "/nested/role"
        },
        hidden: true
      }
    ]
}
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  ...businessRoute,
  ...sampleRoute,
  ...workPlanRoute,
  ...businessApprovalRoute,
  ...supplierRoute,
  ...instrumentRoute,
  ...reagentRoute,
  ...fileManagementRoute,
  ...personRoute,
  ...environmentRoute,
  ...organizationRoute,
  ...baseDataRoute,
  ...systemRoute
];
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js